import { useQuery } from '@tanstack/react-query';
import { ICustomerFullProfile } from '../../interfaces/customer';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../interfaces/errorResponse';
import { FreelancerService } from '../../services/freelancer';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';

interface IProps extends IBaseUseQueryProps<ICustomerFullProfile> {
  id: number;
}

export const FREELANCER_ENTITY_QUERY_KEY = 'freelancer-entity';

export const useGetFreelancerEntity = ({ id, ...props }: IProps) =>
  useQuery<ICustomerFullProfile, AxiosError<IErrorResponse>>({
    queryKey: [FREELANCER_ENTITY_QUERY_KEY],
    queryFn: () => FreelancerService.getOneById(id),
    refetchOnWindowFocus: true,
    retry: 0,
    ...props
  });
